
    var riot = require('riot')
    //src: starling/src/tags/multi-selection-indicator-box.html
riot.tag2('multi-selection-indicator-box',
  '',
  '',
  'hide="{true}" class="selection-area selection-area--indicator {selection-area--selecting: isSelecting()}"', function(opts) {
'use strict';

var _this = this;

var _regionUi = require('lib/region-ui');

var _opts = opts,
    canvas = _opts.canvas;

canvas.multiSelectionIndicatorBox = this;

this.isSelecting = function () {
  return canvas.selecting;
};

this.isMultiSelection = function () {
  return canvas.getSelectedElementsCount() > 1;
};

this.hide = function () {
  _this.root.style.display = 'none';
};

this.on('updated', function () {
  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  var _ref = canvas.getContentExtents({
    nodes: canvas.getSelectedNodes(),
    links: canvas.getSelectedLinks(),
    regions: _regionUi.regionUI.getSelectedRegions()
  }) || [0, 0, 0, 0],
      et = _ref[0],
      el = _ref[1],
      eb = _ref[2],
      er = _ref[3];

  var margin = -0.5;

  _this.root.style = '\n        top: ' + (et - margin) + 'px;\n        left: ' + (el - margin) + 'px;\n        width: ' + (er - el + margin * 2) + 'px;\n        height: ' + (eb - et + margin * 2) + 'px;\n        display: ' + (_this.isMultiSelection() ? 'block' : 'none') + ';\n        z-index: 1;\n      ';
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('multi-selection-indicator-box')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/multi-selection-indicator-box.html
// module id = 787
// module chunks = 0